import {useContext, useEffect, useRef, useState} from "react"
import FloatingContext from "../contexts/FloatingContext"
import useFloating from "../hooks/useFloating"
import ButtonAction from "../commons/ButtonAction"
import Datepicker from "../commons/Datepicker"
import close from "../assets/close-pink.svg"

export default function ConciliationsFilters(){

    const {manageFloating}=useFloating()
    const [floatingContext]=useContext(FloatingContext)
    const value=floatingContext.value || {}
    const liquidationDateFromRef=useRef()
    const liquidationDateToRef=useRef()
    const defaultLiquidationDateFrom=value.defaultLiquidationDateFrom || ""
    const defaultLiquidationDateTo=value.defaultLiquidationDateTo || ""

    const [liquidationDateFrom,setLiquidationDateFrom]=useState(value.liquidationDateFrom || "")
    const [liquidationDateTo,setLiquidationDateTo]=useState(value.liquidationDateTo || "")

    useEffect(()=>{
        setLiquidationDateFrom(value.liquidationDateFrom || "")
        setLiquidationDateTo(value.liquidationDateTo || "")
    },[value.liquidationDateFrom,value.liquidationDateTo])

    const apply=()=>{
        if(value.onApply){
            value.onApply(liquidationDateFrom,liquidationDateTo)
        }
        manageFloating("hide")
    }

    const clear=()=>{
        setLiquidationDateFrom(defaultLiquidationDateFrom)
        setLiquidationDateTo(defaultLiquidationDateTo)
    }

    return(
        <div className="floating-blocks">
            <div className="floating-close-frame">
                <div className="floating-close" onClick={()=>{manageFloating("hide")}}><img src={close} alt="" /></div>
            </div>
            <div className="floating-content">
                <div className="floating-group">Fechas</div>
                <div className="floating-options">
                    <div className="floating-half">
                        <Datepicker ref={liquidationDateFromRef} val={liquidationDateFrom} setVal={setLiquidationDateFrom} label="Desde" />
                        <Datepicker ref={liquidationDateToRef} val={liquidationDateTo} setVal={setLiquidationDateTo} label="Hasta" />
                    </div>
                </div>
            </div>
            <div className="floating-actions">
                <ButtonAction label="Resetear" color="pink" clickEvent={clear} />
                <ButtonAction label="Aplicar" color="purple" clickEvent={apply} />
            </div>
        </div>
    )
}
